module.exports = __webpack_public_path__ + "img/stonks.4f9297b8.svg";